/* @flow */
import React, { useContext, useState, memo } from 'react'
import S from './Header33.styled'
import THEME from './Header33.theme'
import { validation } from './Header33.consts'
import ActionGetter from './Actions'
import NavBar from '@website/common/components/NavBar'
import Show from '@website/common/components/Show/Show'
import Socials from '@website/common/components/Socials'
import EditableContent from '@website/common/components/EditableContent'
import { DispatchContext, EditingContext } from '@contexts'
import Buttons from '@website/common/components/Buttons'

const Header33 = memo(props => {
  const {
    data: {
      title,
      titleAlignment,
      buttons,
      logoSrc,
      logoColor,
      logoWidth,
      logoDimensions,
      backgroundImgUrl,
      backgroundImgDimensions,
      bgOverlayTransparency,
      socials
    }
  } = props
  const dispatcher = useContext(DispatchContext)
  const Actions = ActionGetter(dispatcher)
  const { isEditing } = useContext(EditingContext)
  const [navBarHeight, setNavBarHeight] = useState(0)

  return (
    <S.StyledContainer
      topOffset={navBarHeight}
      isEditing={isEditing}
      backgroundImgUrl={backgroundImgUrl}
      bgOverlayTransparency={bgOverlayTransparency}
      backgroundImgDimensions={backgroundImgDimensions}
    >
      <NavBar
        handleHeightChange={setNavBarHeight}
        alwaysShowBackground
        theme={THEME}
        logoProps={{
          logoSrc,
          logoColor,
          logoWidth,
          logoSizes: logoDimensions
        }}
        linksProps={{
          additionalContent:
            isEditing || socials.length !== 0
              ? () => (
                  <Socials
                    className="header-socials"
                    data={socials}
                    componentDispatcher={dispatcher}
                  />
                )
              : null
        }}
      />
      <S.WmCustomContainer>
        <Show when={[title, ...buttons]}>
          <S.HeaderContentContainer>
            <S.HeaderContent>
              <EditableContent
                text={title}
                alignment={titleAlignment}
                as={S.Title}
                required={validation.title.required}
                maxCount={validation.titleMaxChar}
                className="WM_GLOBAL_heading42"
                onChange={Actions.changeTitle}
                changeAlignment={Actions.changeTitleAlignment}
              />
              <Buttons data={buttons} />
            </S.HeaderContent>
          </S.HeaderContentContainer>
        </Show>
      </S.WmCustomContainer>
    </S.StyledContainer>
  )
})

export default Header33
